import { render, staticRenderFns } from "./card-briefing-money.vue?vue&type=template&id=29500342&"
import script from "./card-briefing-money.vue?vue&type=script&lang=js&"
export * from "./card-briefing-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports